import React from 'react';
import {observer} from 'mobx-react';
import {TextArea, WrapperTextArea, CharactersInfo} from './styles';

import {injectIntl} from 'react-intl';

@injectIntl
@observer
class ModalsTextBox extends React.Component {
  render() {
    const {dataCy, isDesktop, handleTextareaChange, placeholder, value, maxFeedbackLength} = this.props;

    return (
      <WrapperTextArea isDesktop={isDesktop}>
        <TextArea
          data-cy={dataCy}
          isDesktop={isDesktop}
          onChange={handleTextareaChange}
          placeholder={placeholder}
          value={value}
        />
        <CharactersInfo isDesktop={isDesktop}>
          {value?.length ?? 0}/{maxFeedbackLength}
        </CharactersInfo>
      </WrapperTextArea>
    );
  }
}

export default ModalsTextBox;
